import React from 'react';
import Text from '@/components/ui/Text';
import useSearchStore from './useSearchStore';

const TotalResults = () => {
  const isLoading = useSearchStore(state => state.isLoading);
  const numResults = useSearchStore(state => state.numResults);

  const text = () => {
    if (numResults === undefined || isLoading) return <>&nbsp;</>;
    if (numResults === 0) return 'RESULTS (0)';

    return `RESULTS (1 - ${numResults})`;
  };

  return (
    <p className="tw-font-bold tw-text-sm tw-mb-2">
      <Text size="sm" variant="body" weight="extrabold">{text()}</Text>
    </p>
  );
};

export default TotalResults;
